import { HttpClient, OpalApiResponseDocument } from '@opallabs/api'

type AssetReference = OpalApiResponseDocument<'ReadAssetReferencesV1', 200>

type CreateAssetReferenceOptions = Readonly<{
  assetReference: AssetReference
  brandId: string | null
}>

const buildAssetReferencePayload = (
  assetReference: AssetReference,
  brandId: string | null
) => ({
  data: {
    attributes: {
      ...assetReference,
    },
    relationships: {
      brand: {
        data: brandId != null ? { id: brandId, type: 'brand' } : null,
      },
    },
  },
})

const createAssetReference = async ({
  assetReference,
  brandId,
}: CreateAssetReferenceOptions) => {
  const payload = buildAssetReferencePayload(assetReference, brandId)
  const { data } = await HttpClient().post<AssetReference>(
    '/api/v1/asset_references/',
    payload
  )

  return data
}

export default createAssetReference
